import $ from "jquery";
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";

import {
    _dataFromMap,
    _getSplitBar,
    _initSplitBarEvent,
} from "../comJs";

import {
    stationPanelUtils,
    initStationTypeSelComEvent
} from "../../../jsCom/goAclDialog/components/stationCommon";
import GoTabUrl from "../goTabsUrl";

class StationUserTab extends TabCell {

    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        this.dataFrom = _dataFromMap["user"];
        this.tabIdName = "stationUser";
        this.tabLabel = "岗位人员";
        this.active = false;
        this.hasSaveGroup = false;
        this.downMin = "common";
        this.hasType=vueObj.hasType;
        this.vueObj = vueObj;
        this.goTabs = goTabs;
        this.excludeIds=this.goTabs.excludeIds;
    }

    /**
     * 销毁tab对象
     */
    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.stationGrid != null && AssertUtils.isFunction(this.stationGrid.destructor)) {
            this.stationGrid.destructor();
            this.stationGrid = null;
        }
        //销毁岗位关联用户的列表信息
        if (this.waitSelGrid != null && AssertUtils.isFunction(this.waitSelGrid.destructor)) {
            this.waitSelGrid.destructor();
            this.waitSelGrid = null;
        }

    }

    /**
     * 初始化leftcell对象
     * @param panelHeight
     */
    getLeftCellContent(panelHeight) {
        this.leftTopCellHeight = parseFloat(panelHeight + "") * 0.5 - 80;
        this.leftBottomCellHeight = parseFloat(panelHeight + "") * 0.5 - 20;
        this.topSpaceHeight = 78;
        this.panelHeight = panelHeight;

        let stationGridHeight = this.leftTopCellHeight + "px";
        let selUserGridHei = this.leftBottomCellHeight + "px";
        let userGridHeight = this.leftBottomCellHeight + "px";
        return `${stationPanelUtils.getStationPanelHeader(this)} 
           <div class="depart-tree-div">
               <div id="${
            this.tabId
            }_left_top_cell_grid" style="height: ${stationGridHeight};"></div>
            </div>${_getSplitBar()} 
            <div class="wait-sel-user" style="height: ${selUserGridHei};">
                  <div id="${
            this.tabId
            }_userGrid" style="height: ${userGridHeight};"></div>
             </div>
           `;
    }

    _executeCellChangeAfter(panelHeight) {
        $(`#${this.tabId}_station_grid`).css("height", panelHeight);
        this.stationGrid.setSizes();
    }

    getRightCellContent(panelHeight) {
        return stationPanelUtils.initRightCellContent(panelHeight, this);
    }

    /**
     *  初始化岗位待选数据
     */
    initStationGrid() {
        let cellObj = this;

        let selStation = false;
        if (cellObj.itemConfig["selStation"]) {
            selStation = true;
        }

        let clickFun = function (rowId) {
            cellObj.searchStationUser(rowId);
        };

        let selGrid = stationPanelUtils.initStationGrid(cellObj, false, false, false, selStation, clickFun);
        //隐藏横向滚动条
        $("#" + this.tabId + "_station_grid .objbox").css("overflow-x", "hidden");
        (cellObj).stationGrid = selGrid;
    }

    //将数据添加到已选表格中
    addStationRecordToAlreadyGrid(rowId, orgGrid,dataFrom) {
        stationPanelUtils._addStationRecordToAlreadyGrid(this, rowId, orgGrid, dataFrom||this.dataFrom);
    }

    /**
     * 查询岗位下的用户信息
     * @param rowId
     */
    searchStationUser(rowId) {
        let params = {};
        (params)["realName"] = $("#" + this.tabId + "_body")
            .find(".search_userName_input")
            .val();
        if (AssertUtils.isNotEmpty(rowId)) {
            this.waitSelGrid.flushGridByUrl({
                url: GoTabUrl.getUserByStationId(rowId),
                params
            });
        } else {
            this.waitSelGrid.flushGridByUrl({
                url: GoTabUrl.queryAllUser,
                params
            });
        }
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        //初始化岗位表格信息
        this.initStationGrid();

        let backFun=()=>{
            this.excludeIds&&this.excludeIds.forEach((recordId)=>{
                if(AssertUtils.isNotEmpty(recordId)){
                    this.waitSelGrid.deleteRow(recordId);
                }
            });
        };
        //待选用户数据
        this.initWaitGrid(this.tabId + "_userGrid",backFun);
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //初始化账套选择信息
        this.initAccountDefVal(this.getLoadFormStorageFlag(), this);
        //初始化账套缺省默认值
        stationPanelUtils.initStationTypeDefVal(this);
        this.initCtlEvent();
    }

    //选择账套信息
    changeAccountEvent(nodeId, cellObj) {
        //重新加载岗位表格信息
        cellObj.stationGrid.flushGridByUrl({params:stationPanelUtils.getLoadGridParams(cellObj),url:GoTabUrl.queryStationByAccount(nodeId),backFun: () => {
            cellObj.initFirstData = true;
            cellObj.excludeIds&&cellObj.excludeIds.forEach((recordId)=>{
                cellObj.stationGrid.deleteRow(recordId);
            });
        }});
        //清空岗位下用户表格信息
        cellObj.waitSelGrid.clearAll();
    }


    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        //初始化图片按钮事件
        this.initIconBtnEvent();
        //初始化岗位类别选择事件
        this.initStationTypeSelEvent();

        this.initDefEvent({
            searchFun: function () {
                tabCellObj.stationGrid.reloadData(stationPanelUtils.getLoadGridParams(tabCellObj));
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        this.searchAlReadyRecord(this);

    }

    /**
     * 初始化当前panel的表格数据
     */
    loadSysDefData() {

    }


    //查询待选择的用户
    searchWaitForUser() {
        let rowId = this.stationGrid.getSelectedRowId();
        this.searchStationUser(rowId);
    }

    /**
     * 初始化岗位类别选择事件
     */
    initStationTypeSelEvent() {
        let cellObj = this;
        let selStationTypeFun = function () {
            //根据岗位类型查询岗位表格刷新数据
            cellObj.stationGrid.reloadData(stationPanelUtils.getLoadGridParams(cellObj));
        };
        //输入框事件
        initStationTypeSelComEvent(this.tabId, selStationTypeFun);
    }

    allCheckBoxClick() {
    }

    removeSelectedRecord(rId, dataFrom) {
        if (dataFrom === "用户") {
            this.waitSelGrid.setRowIsNotSelected(rId);
        } else {
            this.stationGrid.setRowIsNotSelected(rId);
        }
    }
}

function initStationUserTab(goTabs, vueObj) {
    let groupTab = new StationUserTab(vueObj, goTabs);
    goTabs.addTabToFactory("stationUser", groupTab);
}

export default initStationUserTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/stationUserTab.js